enum CheckboxTypeEnum {
  DEFAULT,
  SWITCH,
}

export default CheckboxTypeEnum;
